import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#1B1A55",
    },
    secondary: {
      main: "#ffeb3b",
    },
  },
  typography: {
    fontFamily: "Oswald",
    fontWeight: "bold",
  },
  button: {
    fontFamily: "Oswald",
    fontWeight: "bold",
  },
  textFiled: {
    height: "20px",
    fontFamily: "Oswald",
  },
  text: {
    fontFamily: "Open Sans",
    fontWeight: "bold",
  },
  span: {
    fontFamily: "Oswald",
    fontWeight: "bold",
  },
});
export default theme;
